module.exports = `<div class="cap-picker option-type-<%= type %> <%= image ? '' : 'no-image' %>" id="cap-option-<%= id %>">
  <label for="option-radio-<%= id %>">
    <input type="checkbox" id="option-radio-<%= id %>" name="checkboxes" value="<%= id %>" class="option-check" />
    <span class="picker-label">
      <span class="picker-clear">
        <% if(image) { %>
          <img src="<%= window.CAP_IMG_DIR + '/' + image %>" alt="" class="picker-img" />
        <% } %>
        <span class="picker-title"><%= code %></span>
        <span class="picker-width"><%= width ? ('[' + width + 'mm]') : '' %></span>
        <span class="picker-description"><%= description %></span>
        <span class="picker-footnote"><%= display_name %></span>
      </span>
    </span>
    <span class="picker-tooltip" role="tooltip"></span>
  </label>
</div>`